module.exports = __webpack_public_path__ + "static/media/tpms.15440749.svg";